import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: left;
  flex-direction: column;
  margin-left: 210px;
  .row {
    display: flex;
    margin: 0 10px 0 20px;
    line-height: 30px;
    > span {
      display: inline-block;
      font-size: 14px;
      font-weight: 600;
      width: 60px;
    }
  }
  .legends {
    display: flex;
    margin: 0;
    padding: 0;
    list-style: none;
    flex-flow: row wrap;
    li {
      display: flex;
      align-items: center;
      padding: 0 5px 0 0;
      margin-left: 20px;
      font-size: 14px;
    }
  }
`;

export const StyledLegend = styled.img`
  width: 12px;
  height: 12px;
  margin-right: 6px;
`;
